// Add DataTables imports
require('jquery');
require('datatables.net');
require('datatables.net-dt');

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
